var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a',{class:_vm.aClass,attrs:{"href":"https://www.changirecommends.com/","data-cy":"changirecommends-logo"}},[_c('img',{staticClass:"changirecommends-logo",class:[
      { 'changirecommends-logo--small': _vm.small },
      { 'changirecommends-logo--medium': _vm.medium },
    ],style:({ width: _vm.width }),attrs:{"src":_vm.getAssetImage('cts-logo-new.png'),"alt":"changirecommends-logo"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }